/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cli_TitleInputs */

const en_mk_cli_title = /** @type {(inputs: Mk_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your agent already knows how to use Bystep`)
};

const id_mk_cli_title = /** @type {(inputs: Mk_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent-mu sudah tahu cara memakai Bystep`)
};

/**
* | output |
* | --- |
* | "Your agent already knows how to use Bystep" |
*
* @param {Mk_Cli_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cli_title = /** @type {((inputs?: Mk_Cli_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cli_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cli_title(inputs)
	return en_mk_cli_title(inputs)
});